import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    showSimilarSubmissionsModal: false,
}

const instantFeedbackSlice = createSlice({
    name: 'instantFeedback',
    initialState,
    reducers: {
        toggleSimilarSubmissionsModal: state => {
            state.showSimilarSubmissionsModal = !state.showSimilarSubmissionsModal
        },
        reset: () => initialState,
    },
})

export const { toggleSimilarSubmissionsModal } = instantFeedbackSlice.actions

export default instantFeedbackSlice.reducer
